/**
 * Single post sidebar: marks the section being read in the "In this update" list (.ssf-toc).
 * The list and the heading ids come from inc/views.php; links are plain anchors, so motion.js
 * glides to them with Lenis and stops clear of the sticky header.
 */
( function () {
	'use strict';

	var links = Array.prototype.slice.call( document.querySelectorAll( '.ssf-toc a[href^="#"]' ) );
	if ( ! links.length ) {
		return;
	}

	var pairs = links
		.map( function ( link ) {
			return { link: link, target: document.getElementById( decodeURIComponent( link.hash.slice( 1 ) ) ) };
		} )
		.filter( function ( pair ) {
			return pair.target;
		} );

	var current = null;
	function setActive( pair ) {
		if ( pair === current ) {
			return;
		}
		if ( current ) {
			current.link.classList.remove( 'is-active' );
			current.link.removeAttribute( 'aria-current' );
		}
		if ( pair ) {
			pair.link.classList.add( 'is-active' );
			pair.link.setAttribute( 'aria-current', 'true' );
		}
		current = pair;
	}

	// The active section is the last heading that has passed a line 30% down the window.
	var ticking = false;
	function update() {
		ticking = false;
		var line = window.innerHeight * 0.3;
		var active = pairs[ 0 ];
		pairs.forEach( function ( pair ) {
			if ( pair.target.getBoundingClientRect().top - line <= 0 ) {
				active = pair;
			}
		} );
		setActive( active );
	}
	function onScroll() {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( update );
		}
	}

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', onScroll );
	update();
}() );
